import { useEffect, useRef, useState } from "react";

export function useScrollNav() {
  const [onMobile, setOnMobile] = useState(false);
  const [selected, setSelected] = useState("account");
  const [mobileOpen, setMobileOpen] = useState(null);
  const [navTopOffset, setNavTopOffset] = useState(0);

  const topBarRef = useRef(null);
  const accountRef = useRef(null);
  const alertsRef = useRef(null);
  const notificationsRef = useRef(null);
  const privacyRef = useRef(null);
  const systemRef = useRef(null);
  const accessControlRef = useRef(null);

  useEffect(() => {
    function handleResize() {
      setOnMobile(window.innerWidth < 1024);
      const headerHeight = topBarRef.current
        ? topBarRef.current.getBoundingClientRect().height
        : 0;

      setNavTopOffset(headerHeight + 12);
    }

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function scrollWithOffset(ref) {
    if (!ref.current) {
      return;
    }

    const y =
      ref.current.getBoundingClientRect().top +
      window.pageYOffset -
      navTopOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  }

  const sectionRefs = {
    account: accountRef,
    alerts: alertsRef,
    notifications: notificationsRef,
    privacy: privacyRef,
    system: systemRef,
    "access-control": accessControlRef,
  };

  function handleScroll(section) {
    setSelected(section);

    if (sectionRefs[section]) {
      scrollWithOffset(sectionRefs[section]);
    }
  }

  return {
    onMobile,
    selected,
    mobileOpen,
    setMobileOpen,
    navTopOffset,
    topBarRef,
    accountRef,
    alertsRef,
    notificationsRef,
    privacyRef,
    systemRef,
    accessControlRef,
    handleScroll,
  };
}
